const sortByKeys =
  (keyString, ascending = true, secondaryKeyString = null) =>
  (a, b) => {
    const sortOrder = ascending ? 1 : -1
    const keys = keyString.split('.')
    const aKey = keys.reduce((prev, curr) => prev[curr], a)
    const bKey = keys.reduce((prev, curr) => prev[curr], b)

    if (aKey === undefined) return 1
    if (bKey === undefined) return 0
    if (aKey < bKey) return -1 * sortOrder
    if (aKey > bKey) return 1 * sortOrder
    if (aKey === bKey && secondaryKeyString) {
      const aSecondary = a[secondaryKeyString]
      const bSecondary = b[secondaryKeyString]
      if (aSecondary < bSecondary) return -1
      if (aSecondary > bSecondary) return 1
      return 0
    }
    return 0
  }

export default sortByKeys
